// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"67baf9c7","453":"926f0775","455":"ae589a5e"}[chunkId] + ".chunk.js";
};